export const state = {
  availableComponents: [
    {
      id: 'BasicTable',
      name: 'Basic Table',
      image: 'images/logo-blanco.png'
    },
    {
      id: 'BasicKPI',
      name: 'Basic KPI',
      image: 'images/logo-blanco.png'
    },
    {
      id: 'BasicHtml',
      name: 'Basic Html',
      image: 'images/logo-blanco.png'
    },
    {
      id: 'BasicFilter',
      name: 'Basic Filter',
      image: 'images/logo-blanco.png'
    },
    {
      id: 'BasicChart',
      name: 'Basic Chart',
      image: 'images/logo-blanco.png'
    },
    {
      id: 'AutoRefresh',
      name: 'Auto Refresh',
      image: 'images/logo-blanco.png'
    }
  ],
  connections: [
    {
      id: 'index',
      type: 'plaka',
      url: 'https://api.plakastudio.com/api/1.0/',
      folder: 'ROOT',
      abstraction: '9584968c5fad4398b69ed5f172ad0107',
      idStatistic: '[SensoresDaCasa]',
      idSchema: '[charlas]'
    }
  ],
  views: {
    index: {
      metaInfo: {
        title: 'PAGINA 2',
        titleTemplate: '%s - Yay!',
        htmlAttrs: {
          lang: 'es',
          amp: true
        }
      },
      viewClass: 'row',
      components: [
        {
          type: 'BasicChart',
          connection: 'index',
          parentClass: 'mb-4 six columns',
          plkparams: {
            type: 'Bar',
            height: '400px',
            showFiltersInHeader: true,
            title: 'Información por hora nas patacas',
            options: {
              legend: false
            },
            dimension: [
              {
                type: 'COLUMN',
                idElement: '[Sensor].[Dia].[Dia]'
              },
              {
                type: 'COLUMN',
                idElement: '[Sensor].[Hora].[Hora]'
              },
              {
                type: 'COLUMN',
                idElement: '[Sensor].[Minuto].[Minuto]'
              }
            ],
            datasets: [
              {
                measure: {
                  type: 'MEASURE',
                  idElement: '[Measures].[MediaSensor]'
                },
                label: 'Métrica 1',
                backgroundColor: ['#55000', 'red', '#D46A6A', 'blue', '#FFAAAA']
              }
            ],
            conditions: [
              {
                type: 'COLUMN',
                idElement: '[Sensor].[Tipo].[Tipo]'
              },
              {
                type: 'COLUMN',
                idElement: '[Sensor].[Ano].[Ano]'
              },
              {
                type: 'COLUMN',
                idElement: '[Sensor].[Mes].[Mes]'
              },
              {
                type: 'COLUMN',
                idElement: '[Sensor].[Tipo].[Tipo]'
              }
            ]
          }
        },
        {
          type: 'BasicFilter',
          connection: 'index',
          parentClass: 'mb-4 six columns',
          menu: false,
          plkparams: {
            title: 'Año',
            placeholder: 'Año',
            multiple: true,
            taggable: true,
            options: {
              dimension: {
                type: 'COLUMN',
                idElement: '[Sensor].[Ano].[Ano]'
              }
            }
          }
        },
        {
          type: 'BasicFilter',
          connection: 'index',
          parentClass: 'mb-4 six columns',
          menu: false,
          plkparams: {
            title: 'Mes',
            placeholder: 'Mes',
            multiple: true,
            taggable: true,
            options: {
              dimension: {
                type: 'COLUMN',
                idElement: '[Sensor].[Mes].[Mes]'
              }
            }
          }
        },
        {
          type: 'BasicFilter',
          connection: 'index',
          parentClass: 'mb-4 six columns',
          menu: false,
          plkparams: {
            title: 'Dia',
            placeholder: 'Filtro de dia',
            multiple: true,
            options: {
              list: [
                {
                  id: '13',
                  value: '13'
                }
              ],
              dimension: {
                type: 'COLUMN',
                idElement: '[Sensor].[Dia].[Dia]'
              }
            }
          }
        },
        {
          type: 'BasicFilter',
          connection: 'index',
          parentClass: 'mb-4 six columns',
          menu: false,
          plkparams: {
            title: 'Minuto',
            placeholder: 'Minuto',
            multiple: true,
            taggable: true,
            options: {
              dimension: {
                type: 'COLUMN',
                idElement: '[Sensor].[Minuto].[Minuto]'
              }
            }
          }
        }
      ]
    },
    example: {
      metaInfo: {
        title: 'PAGINA 2',
        titleTemplate: '%s - Yay!',
        htmlAttrs: {
          lang: 'es',
          amp: true
        }
      },
      viewClass: 'row',
      components: [
        {
          type: 'BasicFilter',
          connection: 'index',
          parentClass: 'pt-5 twelve columns',
          menu: false,
          plkparams: {
            title: 'COSA',
            placeholder: 'COSA',
            multiple: true,
            taggable: true,
            options: {
              dimension: {
                type: 'COLUMN',
                idElement: '[Sensor].[Ano].[Ano]'
              }
            }
          }
        }
      ]
    }
  },
  javascript: '',
  style: ''
}
